import * as React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControlLabel,
    IconButton,
    DialogTitle,
    Slide,
    Box,
    Grid,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { EditMode } from '../Types';
import { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import RecordPic from '../../../Assets/recordpic.png';
import RadioButtonIcon from '../../../Assets/radio_button_checked.png';
import { CloseIcon } from 'src/Assets/svgs/CloseIcon';

const styles = makeStyles((theme) => ({
    paper: {
        borderRadius: '5px',
        width: '500px',
        maxWidth: '100%',
        boxSizing: 'border-box',
    },
    contentText: {
        fontSize: '15px',
        color: 'rgba(250, 250, 250, 0.8)',
        textAlign: 'left',
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
        fontWeight: 200,
        lineHeight: '28px',
        marginBottom: 4,
    },
    buttonContainer: {
        display: 'block',
        padding: '0px',
    },
    button: {
        color: theme.palette.common.white,
        marginBottom: '10px',
        marginRight: '10px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        width: '28%',
        fontSize: '14px',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    actionFooterCss: {
        borderTop: '1px solid #3F3F50',
        padding: '16px',
        textAlign: 'right' as 'right',
        gap: 8,
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: '0 !important',
        '& button': {
            borderRadius: 8,
            padding: '0 16px',
            height: 40,
            fontWeight: 400,
            textTransform: 'capitalize',
            '&.MuiButton-contained:hover': {
                backgroundColor: '#B3211E',
            },
        },
    },
    checkboxContaner: {
        alignSelf: 'flex-end',
        margin: '0 0 8px',
        padding: '0px',
        paddingLeft: '10px',

        '& .MuiFormControlLabel-label': {
            fontSize: '13px',
            color: 'rgba(250, 250, 250, 0.8)',
            fontWeight: 300,
        },
        '& .checkbox-wrapper': {
            '& svg': {
                width: 18,
                height: 18,
                borderRadius: '50%',
            },
        },
    },
    cardHeaderCss: {
        cursor: 'pointer',
        borderBottom: '1px solid #3F3F50',
    },
    dialogBox: {
        backgroundColor: '#121217',
        zIndex: 999999,
        margin: 0,
        padding: 0,
        border: '1px solid #3F3F50',
        borderRadius: '8px',
    },
    dialogHeader: {
        padding: '12px 16px',
        borderBottom: '1px solid #3F3F50',
        '& .close-icon': {
            cursor: 'pointer',
            width: 38,
            height: 38,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            '&:hover': {
                backgroundColor: 'rgba(250, 250, 250, 0.1)',
            },
        },
    },
    dialogTitle: {
        // padding: `${theme.spacing(1.25)}px ${theme.spacing(0.5)}px`,
        '&&': {
            // doubles the class selector to increase specificity
            padding: 0,
            '& h2': {
                fontSize: 16,
            },
        },
    },
}));

interface IProps {
    editMode: EditMode;
    open: boolean;
    updateRecordDialogStatus: (status: boolean) => void;
}

const Transition = React.forwardRef(
    (
        props: TransitionProps & { children?: React.ReactElement<any, any> },
        ref: React.Ref<unknown>
    ) => <Slide direction='up' ref={ref} {...props} timeout={800} />
);

export function RecordDialog({
    editMode,
    open,
    updateRecordDialogStatus,
}: IProps) {
    const videoRef = useRef<HTMLVideoElement>(null);
    const classes = styles();
    const doNotShowPrompt = localStorage.getItem('doNotShow_record') === 'true';
    useEffect(() => {
        if (!open && editMode !== 'record_first_mount') {
            updateRecordDialogStatus(true);
        }
    }, [editMode]);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.checked) {
            localStorage.setItem('doNotShow_record', 'true');
        } else {
            localStorage.removeItem('doNotShow_record');
        }
    }

    useEffect(() => {
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.loop = true;
            videoElement.controls = true; // Add controls attribute
            videoElement.play().catch((error) => {
                console.error('Error playing video:', error);
            });
        }
    }, [videoRef]);

    return !doNotShowPrompt ? (
        <Dialog
            open={editMode === 'record_first_mount' && open}
            // open={true}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => updateRecordDialogStatus(false)}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
            classes={{ paper: classes.paper }}
        >
            <Box className={classes.dialogBox} style={{ maxWidth: '100%' }}>
                <Grid
                    container
                    spacing={0}
                    alignItems='center'
                    className={classes.dialogHeader}
                >
                    <Grid item xs={9}>
                        <Box display='flex' alignItems='center'>
                            <img
                                src={RadioButtonIcon}
                                alt='edit video'
                                width='16'
                                height='16'
                                style={{ marginRight: 12 }}
                            />
                            <DialogTitle className={classes.dialogTitle}>
                                Share your analysis
                            </DialogTitle>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display='flex' justifyContent='flex-end'>
                            <span
                                // aria-label='Close modal'
                                onClick={() => updateRecordDialogStatus(false)}
                                className={'close-icon'}
                            >
                                <CloseIcon />
                            </span>
                        </Box>
                    </Grid>
                </Grid>
                <DialogContent
                    style={{
                        padding: '16px 16px 0',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <img
                        src={RecordPic}
                        width='100%'
                        style={{ borderRadius: 8, paddingBottom: '8px' }}
                    />
                    <DialogContentText
                        id='alert-dialog-slide-description'
                        className={classes.contentText}
                    >
                        Use the recording feature to create clips which you can
                        save and share. Hit the record button to get started.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.buttonContainer}>
                    <div>
                        <FormControlLabel
                            className={classes.checkboxContaner}
                            style={{ fontSize: '14px' }}
                            control={
                                <Checkbox
                                    onChange={handleChange}
                                    style={{
                                        color: 'rgba(250, 250, 250, 0.3)',
                                    }}
                                    className='checkbox-wrapper'
                                />
                            }
                            label='Don’t show this message again'
                        />
                    </div>
                    <div className={classes.actionFooterCss}>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={() => updateRecordDialogStatus(false)}
                        >
                            Start
                        </Button>
                    </div>
                </DialogActions>
            </Box>
        </Dialog>
    ) : (
        <></>
    );
}
